// extracted by mini-css-extract-plugin
export var date = "Event-module--date--1aHgj";
export var num = "Event-module--num--23Dm4";
export var eventTitle = "Event-module--event-title--2Mn06";
export var light = "Event-module--light--34hKO";
export var registerBtn = "Event-module--registerBtn--1A6NO";